import { Component } from '@angular/core';

@Component({
    selector: 'vertical-spacer',
    template: '<div style="height: var(--linq-spacing-4);">&nbsp;</div>',
    standalone: true,
})
export class VerticalSpacerComponent {}
